<template>
	<div class="page">
		<div class="content">
			<Breadcrumb :pathList="pathList"></Breadcrumb>
			<div class="flex-only" style="margin-top: 30px;">
				<img :src="detail.img" style="width: 356px;height: 200px;border-radius: 13px;" />
				<div class="right flex-1">
					<div>
						<div class="flex flex-b">
							<div class="name">{{detail.name}}</div>
							<div class="status" v-if="detail.status==1">报名中</div>
							<div class="status status2" v-if="detail.status==2">进行中</div>
							<div class="status status3" v-if="detail.status==3">已结束</div>
						</div>
						<div class="flex">
							<div class="flag flex flex-c">{{detail.train_cate_name}}</div>
							<!-- <div class="flag flex flex-c">基础操作</div> -->
						</div>
					</div>
					<div class="wxbtn pointer" v-if="detail.status==1" @click="showCancle = true">取消报名</div>
				</div>
			</div>
			<div class="flex-only">
				<div>
					<div class="titles">培训介绍</div>
					<div style="width: 884px;" v-html="detail.desc"></div>
					<!-- <img src="../../assets/images/home/logo.png" style="width: 844px;height: 1144px;" /> -->
				</div>
				<div class="flex-1" style="margin-left: 20px;">
					<div class="titles">培训详情</div>
					<div class="wbox">
						<div class="flex">
							<img src="../../assets/images/icon/irl.png" style="width: 16px;height: 16px;" />
							<div class="tit">培训时间</div>
						</div>
						<div class="time">{{detail.begin_time}} 至 {{detail.end_time}}</div>
						<div class="flex">
							<img src="../../assets/images/icon/idz.png" style="width: 16px;height: 16px;" />
							<div class="tit">培训地点</div>
						</div>
						<div class="time">{{detail.address}}</div>
						<div class="flex">
							<img src="../../assets/images/icon/time.png" style="width: 16px;height: 16px;" />
							<div class="tit">报名时间</div>
						</div>
						<div class="time">{{detail.sign_begin_time}} 至 {{detail.sign_end_time}}</div>
						<div class="flex">
							<img src="../../assets/images/icon/rs.png" style="width: 16px;height: 16px;" />
							<div class="tit">报名情况</div>
						</div>
						<div class="time flex">
							<div class="borRight flex">剩余：<span>{{detail.num-detail.order_num}}</span> 人</div>
							<div style="padding-left: 10px;">总名额：{{detail.num}}人</div>
						</div>
						<div class="flex">
							<img src="../../assets/images/icon/ipoint.png" style="width: 16px;height: 16px;" />
							<div class="tit">积分奖励</div>
						</div>
						<div class="fee">{{detail.is_get_score==1?detail.get_score+'积分':'无积分奖励'}}</div>
						<div class="flex">
							<img src="../../assets/images/icon/dj.png" style="width: 16px;height: 16px;" />
							<div class="tit">最低报名会员等级</div>
						</div>
						<div class="time">{{detail.member_name}}</div>
					</div>
					<div class="flex flex-b">
						<div class="titles">个人相关信息</div>
						<div class="tt">仅用于线下签到匹配对应人员</div>
					</div>
					<div class="gbox" style="margin-top: 0;">
						<div class="flex flex-b botl">
							<div class="t">手机号</div>
							<div class="t2">{{detail.phone}}</div>
						</div>
						<div class="flex flex-b botl">
							<div class="t">所属企业</div>
							<div class="t2">{{detail.business_name?detail.business_name:'暂未绑定企业'}}</div>
						</div>
						<div class="flex flex-b botl">
							<div class="t">真实姓名</div>
							<div class="t2">{{detail.real_name}}</div>
						</div>
					</div>
					<div class="titles">订单信息</div>
					<div class="gbox">
						<div class="flex flex-b botl">
							<div class="t">支付方式</div>
							<div class="t2">{{detail.pay_type==2?'积分支付':detail.pay_type==1?'微信支付':'免费'}}</div>
						</div>
						<div class="flex flex-b botl">
							<div class="t">实际支付</div>
							<div class="score4" v-if="detail.pay_type==2">{{detail.score}}<span>积分</span></div>
							<div class="score4" v-if="detail.pay_type==1">￥{{detail.price}}</div>
							<div class="score4" v-if="detail.pay_type==3">0</div>
						</div>
						<div class="flex flex-b botl">
							<div class="t">完成购买时间</div>
							<div class="t2">{{detail.pay_time}}</div>
						</div>
					</div>

				</div>
			</div>
		</div>
		<el-dialog :visible.sync="showCancle" width="360px" :close-on-click-modal='false' :show-close="false"
			:close-on-press-escape='false'>
			<div class="cancleBox flex-column-item">
				<div class="tit">取消报名请电联</div>
				<div class="number">{{detail.cancel_phone}}</div>
				<div class="wxbtn pointer" @click="showCancle=false">我知道了</div>
			</div>
		</el-dialog>
		<toTop></toTop>
		<Footer></Footer>
	</div>
</template>

<script>
	import Utils from "@/jslibs/utils";
	import {
		getTrainOrderDetail
	} from "@/api/train";
	import {
		getMyCourse,
		getUser,
		EditUser,
	} from '@/api/mine';
	import Breadcrumb from '../../components/Breadcrumb.vue'
	import toTop from '../../components/toTop.vue'
	import Footer from '../../components/Footer.vue'
	export default {
		data() {
			return {
				pathList: [{
					title: '我的',
					path: '/mine'
				}, {
					title: '我的培训',
					path: '/myTraining'
				}, {
					title: '这是一个培训名称',
					path: ''
				}],
				showBackToTop: false,
				loginUser: '',
				detail: '',
				showCancle: false
			}
		},
		components: {
			Breadcrumb,
			Footer,
			toTop
		},
		mounted() {
			if (Utils.getCookie('loginUser')) {
				this.getUser()
			}
			this.uuid = this.$route.query.id
			this.getTrainOrderDetail()
		},
		methods: {
			async getTrainOrderDetail() {
				const {
					data,
					status
				} = await getTrainOrderDetail({
					uuid: this.uuid,
				})
				this.detail = data.result
			},
			async getUser() {
				const {
					status,
					data
				} = await getUser({})
				this.loginUser = data.result
			},
			toPage(path) {
				this.$router.push({
					path: path
				})
			},
		},
	}
</script>

<style lang="less" scoped>
	.cancleBox {
		.tit {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 18px;
			color: #333333;
		}

		.number {
			margin: 20px 0;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 18px;
			color: #333333;
		}

		.wxbtn {
			width: 298px;
			height: 40px;
			border-radius: 12px 12px 12px 12px;
			border: 2px solid rgba(127, 218, 76, .24);
			display: flex;
			align-items: center;
			justify-content: center;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			text-align: center;
			font-style: normal;
			text-transform: none;
			background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}

	.wxbtn {
		width: 164px;
		height: 40px;
		border-radius: 12px 12px 12px 12px;
		border: 2px solid rgba(127, 218, 76, .24);
		display: flex;
		align-items: center;
		justify-content: center;
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 400;
		font-size: 16px;
		text-align: center;
		font-style: normal;
		text-transform: none;
		background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.page {
		.content {
			padding: 30px 133px 0;

			.right {
				margin-left: 20px;
				height: 200px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.name {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 27px;
					color: #000000;
				}

				.status {
					height: 22px;
					background: #00A73C;
					border-radius: 7px 7px 7px 7px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #FFFFFF;
					line-height: 22px;
					padding: 0 10px;

					&.status2 {
						background: #D7B155;
					}

					&.status3 {
						background: #FC5F5F;
					}
				}

				.flag {
					margin: 10px 0;
					height: 22px;
					padding: 0 10px;
					line-height: 22px;
					margin-right: 10px;
					background: rgba(0, 0, 0, 0.4);
					border-radius: 4px 4px 4px 4px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #FFFFFF;
				}
			}

			.login-btn {
				margin-top: 10px;
				width: 164px;
				height: 50px;
				background: url('../../assets/images/course/btnw164.png') no-repeat;
				background-size: 100% 100%;
				display: flex;
				align-items: center;
				justify-content: center;

				.text {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 16px;
					text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
					text-align: center;
					font-style: normal;
					text-transform: none;
					background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
				}
			}

			.wbox {
				background: #FFFFFF;
				box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
				border-radius: 13px 13px 13px 13px;
				padding: 20px;

				img {
					margin-right: 10px;
				}

				.tit {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #666666;
				}

				.time {
					margin: 4px 0 16px 23px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #333333;

					span {
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: bold;
						font-size: 16px;
						color: #00A73C;
					}
				}

				.borRight {
					padding-right: 10px;
					height: 12px;
					border-right: 1px solid #999;
				}

				.fee {
					margin: 4px 0 16px 23px;
					font-family: DINPro, DINPro;
					font-weight: bold;
					font-size: 18px;
					color: #00A73C;
				}
			}
		}
	}

	.gbox {
		background: #FFFFFF;
		box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
		border-radius: 13px 13px 13px 13px;
		padding: 10px 20px;
		margin: 20px 0;

		.tt {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 13px;
			color: #999999;
		}

		.t {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #333333;
		}

		.t2 {
			font-family: DINPro, DINPro;
			font-weight: 500;
			font-size: 16px;
			color: #333333;
		}

		.score4 {
			font-family: DINPro, DINPro;
			font-weight: bold;
			font-size: 22px;
			color: #00A73C;

			span {
				margin-left: 6px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #00A73C;
			}
		}

		.botl {
			padding: 16px 0;
			border-bottom: 1px solid #EEEEEE;

			&:last-child {
				border-bottom: none;
			}
		}
	}
</style>